/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lp_Login_Subscribedescription2Inputs */

const en_coinvestments_lp_login_subscribedescription2 = /** @type {(inputs: Coinvestments_Lp_Login_Subscribedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review deal materials, sign your NDA, and submit your indicative order`)
};

/**
* | output |
* | --- |
* | "Review deal materials, sign your NDA, and submit your indicative order" |
*
* @param {Coinvestments_Lp_Login_Subscribedescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_login_subscribedescription2 = /** @type {((inputs?: Coinvestments_Lp_Login_Subscribedescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Login_Subscribedescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_login_subscribedescription2(inputs)
});
export { coinvestments_lp_login_subscribedescription2 as "coInvestments_lp_login_subscribeDescription" }